import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { format as formatDate, isDate } from "date-fns";
import { enGB, de as deAT } from "date-fns/locale"; // import all locales we need
import { getLanguageID } from 'app/store/abs/settingsSlice';
const locales = { enGB, deAT }; // used to look up the required locale

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      'Welcome to React': 'Welcome to React and react-i18next',
    },
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    // lng: 'deAT',
    lng: getLanguageID(),

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (value, format, lng) => {
				if (isDate(value)) {
					const locale = locales[lng];
					return formatDate(value, format, { locale });
				}
				return null;
			}
    },
  });

export default i18n;
